import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=aefabf38&scoped=true"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"
import style0 from "./honor.vue?vue&type=style&index=0&id=aefabf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefabf38",
  null
  
)

export default component.exports